<div class="d-flex justify-content-center p-2 busy-overlay-parent">
    <!-- <div *ngIf="isLoading" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
    </div> -->

    <div *ngIf="selectedScoutPoint" class="d-flex flex-row">
        <div class="px-2 text-nowrap">
            <button (click)="changeGuard(selectedScoutPoint, moveToFirst )" class="btn btn-secondary mr-sm-1" [disabled]="!bHasPrevious">
                <i class="fa fa-fast-backward"></i>
            </button>
            <button (click)="changeGuard(selectedScoutPoint, moveToPrevious)" class="btn btn-secondary" [disabled]="!bHasPrevious">
                <i class="fa fa-step-backward"></i>
            </button>
        </div>

        <div class="measurment-bar py-0 px-1 d-flex flex-column"
            [ngStyle]="{'opacity': selectedScoutPoint?.disabled ? 0.5 : 1}">
            <div class="measurement-title"  [ngStyle]="{
            'background-color': selectedScoutPoint.color,
             'text-decoration': selectedScoutPoint.disabled ? 'line-through' : 'none'
            }">
                {{selectedScoutPoint.name}}
            </div>
            <div *ngIf="selectedScoutPoint.type=='HA'; else notHaPoint" class="measurement-subtext">
                {{selectedScoutPoint.pointId}}
            </div>
            <ng-template #notHaPoint>
                <div class="measurement-subtext">
                    {{selectedScoutPoint.exPointId||selectedScoutPoint.type}}
                </div>
            </ng-template>
        </div>

        <div class="px-2 text-nowrap">
            <button (click)="changeGuard(selectedScoutPoint, moveToNext )" class="btn btn-secondary mr-sm-1" [disabled]="!bHasNext">
                <i class="fa fa-step-forward"></i>
            </button>
            <button (click)="changeGuard(selectedScoutPoint, moveToLast )" class="btn btn-secondary" [disabled]="!bHasNext">
                <i class="fa fa-fast-forward"></i>
            </button>
        </div>
    </div>

</div>